import bigcommerceGenericDefaults from '../bigcommerce-generic/config.js';

window.Convermax.handleQtySelector = (event, plus) => {
  const quantitySelectorInput = event.target.closest('form').querySelector('input[name="qty[]"]');

  const currentQty = +quantitySelectorInput.getAttribute('value');
  const minQty = +quantitySelectorInput.getAttribute('min');

  if (!plus && currentQty === minQty) {
    return;
  }

  const newQty = plus ? currentQty + 1 : currentQty - 1;

  quantitySelectorInput.setAttribute('value', newQty);
  quantitySelectorInput.value = newQty;
};

export default {
  ...bigcommerceGenericDefaults,
  includes: ['bigcommerce-generic'],
};
